import React from 'react';

export default function Avatar({ name = '', size = 22 }) {
  const initials = name.trim().split(/\s+/).slice(0, 2).map((w) => w[0] || '').join('').toUpperCase() || '?';
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  const hue = 130 + (h % 70);
  return (
    <span
      className="avatar"
      style={{
        width: size, height: size,
        background: `oklch(0.92 0.04 ${hue})`,
        color: `oklch(0.38 0.08 ${hue})`,
        fontSize: size * 0.42,
      }}
    >
      {initials}
    </span>
  );
}
